import { RegularButton } from "@components/buttons"
import { LoginModal } from "@components/modal/LoginModal"
import { FlexBox } from "@components/wrapper"
import { useUserData } from "@hooks/useUserData"
import { CheckoutSummary } from "@interfaces/checkout"
import { SchoolDetail, SchoolProgram, SchoolProgramType } from "@interfaces/school"
// import { AnalyticsProvider, useAnalytics } from "@lib/context/analytics"
import { createMarkup, priceFormatter } from "@lib/functions"
import clsx from "clsx"
import { useRouter } from "next/router"
import { FC, useState } from "react"
import { ProgramNewCta } from "."
import { InstallmentModal } from "../general/InstallmentModal"
import { ProgramHeading } from "../general/ProgramHeading"

export interface ProgramColumnProps {
  programs: SchoolProgramType[]
  schoolDetail: SchoolDetail
  screenWidth: number
  requirement?: string
}

export const ProgramColumn: FC<ProgramColumnProps> = ({ programs, schoolDetail }) => {
  const [loginModal, setLoginModal] = useState(false)

  const { isLogin, tokenData } = useUserData()
  const router = useRouter()
  const pathName = router.pathname
  // const { analytics } = useAnalytics()

  const [activeTab, setActiveTab] = useState(0)
  const [installmentModal, setInstallmentModal] = useState(false)
  const [installmentType, setInstallmentType] = useState("")

  // Function for program button `daftar sekarang`
  const nextPageHandler = (data: SchoolProgram) => () => {
    // setPackageId(index)
    if (!isLogin) {
      return setLoginModal(true)
    }

    if (programs[activeTab].program_type === "PAY_NOW") {
      try {
        const storage: CheckoutSummary = {
          school_id: schoolDetail.product_id,
          school_slug: schoolDetail.product_slug,
          school_title: schoolDetail.product_name,
          image: schoolDetail.product_asset.product_image,
          program_id: data.id,
          program_description: data.program_description,
          program_title: data.program_title,
          program_price: data.program_price,
          program_sku: data.program_sku,
        }

        if (tokenData.user_active) {
          const isProClass = pathName.includes("proclass")

          window.localStorage.setItem(
            isProClass ? "hsp_checkout" : "hs_checkout",
            JSON.stringify(storage)
          )

          // analytics.track("Product Clicked", {
          //   products: [
          //     {
          //       product_id: data.program_sku,
          //       name: `${schoolDetail.product_name} - ${data.program_title}`,
          //       affiliation: "PT. Karya Kaya Bahagia",
          //       coupon: "",
          //       discount: 0,
          //       currency: "IDR",
          //       brand: "HMS",
          //       category: isProClass ? "ProClass" : "Bootcamp",
          //       variant: data.program_title,
          //       price: data.program_price,
          //       quantity: 1,
          //       position: 0,
          //       item_list_name: schoolDetail.product_name,
          //       item_list_id: schoolDetail.product_id,
          //     },
          //   ],
          //   item_list_name: schoolDetail.product_name,
          //   item_list_id: schoolDetail.product_id,
          // })

          window.location.assign(`/school/${isProClass ? "proclass/checkout" : "checkout"}`)
        } else {
          alert(
            "Akun kamu belum diverifikasi. silahkan coba login ulang jika kamu telah melakukan verikasi"
          )
        }
      } catch (e) {
        alert(e)
        alert("Terjadi kesalahan. Silahkan coba login ulang dan coba lagi")
      }
    }

    if (programs[activeTab].program_type === "INSTALLMENT") {
      setInstallmentType(data?.program_title === "Danacita" ? "Danacita" : "Harisenin")
      return setInstallmentModal(true)
      // return window.open(
      //   // `https://api.whatsapp.com/send?phone=6281312117711&text=Saya%20Mau%20ikut%Program%20Cicilan%20di%20harisenin.com%20min`,
      //   "https://harisenin.link/cYNE1",
      //   "_blank"
      // )
    }
  }

  if (!programs || !programs.length) {
    return <></>
  }

  return (
    // <AnalyticsProvider>
      <div className="relative sm:mb-15" id="fee1">
        <ProgramHeading
          id="fee"
          title="Kategori & Biaya"
          subTitle={`Apa Saja ${
            schoolDetail.school_type === "BOOTCAMP" ? "Program dan Benefit" : "Kategori Biaya"
          } yang Ditawarkan?`}
        />

        <div className={clsx("grid sm:grid-cols-2 w-full", "sm:gap-8 gap-[18px]")}>
          {programs[0].school_programs.map((item) => (
            <div className={clsx("border border-new-grey")} key={item.id}>
              <div className="">
                {/* Best seller ribbon */}
                <div
                  className={clsx(
                    `w-full text-sm py-3 px-3 text-white font-medium tracking-widest uppercase`,
                    item.program_best_seller ? "bg-blue" : "bg-white"
                  )}
                >
                  {item.program_best_seller && "⚡ Best Seller"}
                </div>

                <div className={clsx("px-4 pt-4 pb-6", "px-4")}>
                  {/* Program title */}
                  <div className={clsx("font-semibold text-xl", "sm-only:mb-1")}>
                    {item.program_title}
                  </div>

                  {/* Program description */}
                  <div
                    className="text-sm h-[3em]"
                    dangerouslySetInnerHTML={createMarkup(item.program_description)}
                  />

                  {/* Program Price */}
                  <FlexBox className={clsx("sm:gap-4")} justify="between">
                    <div className="h-[3em]">
                      {Boolean(item.program_discount_percentage) && (
                        <FlexBox align="center" className="gap-2">
                          <div className="text-[10px] text-white bg-red py-0.5 px-1 rounded h-fit">
                            {item.program_discount_percentage * 100}%
                          </div>
                          <div className="text-sm text-[rgba(58,53,65,0.54)] line-through">
                            {priceFormatter(item.program_original_price)}
                          </div>
                        </FlexBox>
                      )}

                      <div className={clsx("sm:text-2xl font-semibold text-xl text-green")}>
                        {priceFormatter(item.program_price)}
                      </div>
                    </div>
                  </FlexBox>

                  <RegularButton
                    variant={"solid-blue"}
                    disabled={!item.can_order}
                    className="!rounded-none h-fit w-full mt-4"
                    customPadding="py-2 sm:px-6 px-[22px]"
                    onClick={nextPageHandler(item)}
                  >
                    Daftar
                  </RegularButton>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={clsx("sm:mt-15", schoolDetail.school_type === "PRO_CLASS" && "mt-8 -mb-8")}>
          <ProgramNewCta/>
        </div>

        <LoginModal onHide={() => setLoginModal(false)} show={loginModal} />
        <InstallmentModal
          onHide={() => setInstallmentModal(false)}
          show={installmentModal}
          type={installmentType}
        />
      </div>
    // </AnalyticsProvider>
  )
}
